require('../modules/es6.date.now');
require('../modules/es6.date.to-json');
require('../modules/es6.date.to-iso-string');
require('../modules/es6.date.to-string');
require('../modules/es6.date.to-primitive');
module.exports = Date;



//////////////////
// WEBPACK FOOTER
// /Users/lsharir/dev/angular-d3-graph-example/node_modules/core-js/es6/date.js
// module id = ../../../../core-js/es6/date.js
// module chunks = polyfills